<template>
  <div class="max-w-lg mx-auto p-4">
    <h1 class="text-xl font-semibold mb-4" v-if="isEditMode">ویرایش اعلامیه</h1>
    <h1 class="text-xl font-semibold mb-4" v-else>افزودن اعلامیه جدید</h1>

    <form @submit.prevent="handleSubmit">
      <div class="mb-4">
        <label for="content" class="block text-sm font-medium text-white">محتوا</label>
        <textarea
          id="content"
          v-model="announcement.content"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          rows="4"
        ></textarea>
      </div>

      <div class="mb-4">
        <label for="buttonText" class="block text-sm font-medium text-white">متن دکمه</label>
        <input
          type="text"
          id="buttonText"
          v-model="announcement.buttonText"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
        />
      </div>

      <div class="mb-4">
        <label for="closeButtonText" class="block text-sm font-medium text-white">متن دکمه بستن</label>
        <input
          type="text"
          id="closeButtonText"
          v-model="announcement.closeButtonText"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
        />
      </div>

      <div class="mb-4">
        <label for="isActive" class="block text-sm font-medium text-white">فعال</label>
        <input
          type="checkbox"
          id="isActive"
          v-model="announcement.isActive"
          class="mt-1"
        />
      </div>

      <div class="flex justify-center mt-6">
        <button type="submit" class="bg-blue-500 text-white px-4 py-2 rounded-lg">
          {{ isEditMode ? "ذخیره تغییرات" : "افزودن" }}
        </button>
        <router-link to="/AnnouncementList" class="bg-gray-500 text-white px-4 py-2 rounded-lg mr-2">لغو</router-link>
  
      </div>
    </form>
  </div>
</template>

<script>
//import { ref, onMounted } from "vue";
import { CreateAnnouncement, UpdateAnnouncement, getAnnouncementById } from "@/API/API.js";
import { useToast } from "vue-toastification";
//import { CreateAnnouncement } from "../API/API";
const toast = useToast();

export default {
  name: "AddAnnouncement",
  data() {
    return {
      announcement: {
        Id:0,
        content: "",
        buttonText: "",
        closeButtonText: "",
        isActive: false
      },
      isEditMode: false
    };
  },
  /*async onMounted() {
    if (this.$route.params.id) {
      this.isEditMode = true;
      this.id=this.$route.params.id
      await this.loadAnnouncement(this.id);
    }
  },*/
  mounted() {
if (this.$route.params.id) {
  this.isEditMode = true;
  this.loadAnnouncement(this.$route.params.id);
}
},
  methods: {
    async loadAnnouncement(id) {
      try {
        console.log(123)
        const result = (await getAnnouncementById(id)).data;
        this.announcement = result;
      } catch (error) {
        console.error("Failed to load announcement:", error);
        toast.error("خطا در بارگذاری اطلاعات اعلامیه");
      }
    },
    async handleSubmit() {
      try {
        if (this.isEditMode) {
          this.announcement.Id = this.$route.params.id;
          console.log(77777);
          console.log(this.announcement);
          await UpdateAnnouncement(this.$store.getters.slug, this.announcement);
          toast.success("اعلامیه با موفقیت به‌روزرسانی شد");
        } else {
          console.log(777);
          console.log(this.announcement);
          this.announcement.StoreId = this.$store.getters.storeId;
          await CreateAnnouncement(this.$store.getters.slug, this.announcement);
          toast.success("اعلامیه با موفقیت اضافه شد");
        }
        this.$router.push("/AnnouncementList");
      } catch (error) {
        console.error("Failed to save announcement:", error);
        toast.error("خطا در ذخیره اعلامیه");
      }
    }
  }
};
</script>
